import React from 'react';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
} from '../../../../../../CommonComponents/OPL/Menu/Menu';
import { IconButton } from '../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { ListItem } from '../../../../../../CommonComponents/OPL/List/ListItem';

interface Props {
  clientId: number;
}

export const ExtraMenu = ({ clientId }: Props) => {
  return (
    <Menu>
      <MenuTrigger>
        <IconButton aria-label="Menu" icon="fas fa-ellipsis-h" variant="subtleInactive" />
      </MenuTrigger>

      <MenuContent align="end">
        <MenuItem
          onSelect={() => {
            ADV.util.Router.go2('AssetBucketingEdit', { clientId });
          }}
        >
          <ListItem icon="far fa-pencil">Edit Asset Bucketing</ListItem>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};
